import React from "react";
import classNames from "classnames";

interface CardTitleProps {
    className?: string;
    [x: string]: any;
}

export const CardTitle = ({ className, ...props }: CardTitleProps) => (
    <h5 className={classNames("card-title", className)} {...props}>
        {props.children}
    </h5>
);
